import { createAPI } from '@common'

export default {
  // 多个id进行撤稿
  postArticlesRevokeById: config => createAPI('customEncryptApiName-1/0w20bsujdmft0sfwplfCzJe', 'post', config),
  // 撤稿
  postArticlesRevoke: config => createAPI('customEncryptApiName-1/0w20bsujdmft0sfwplf', 'post', config),
  // 删除
  postArticlesDelete: config => createAPI('customEncryptApiName-1/0w20bsujdmft0efmfuf', 'post', config)
}
